import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { fromLocalStorage, toLocalStorage } from 'util/util'; 

interface TutorialPersistedState {
    tutorialViewed: boolean
}

interface TutorialScreens {
    controls: boolean,
    objective: boolean,
    bumpers: boolean,
    achievements: boolean,
    rank: boolean
}

const getTutorialScreenState = () : TutorialScreens => ({
    controls: false,
    objective: false,
    bumpers: false,
    achievements: false,
    rank: false
})

const useTutorialStore = defineStore('tutorial-store', () => {
    let persisted : TutorialPersistedState = fromLocalStorage('tutorial-store', {
        tutorialViewed: false
    })

    const tutorialViewed = ref<boolean>(persisted.tutorialViewed);
    const tutorialActive = ref<boolean>(false);
    const screens = ref<TutorialScreens>(getTutorialScreenState());
    const activeScreen = ref<keyof TutorialScreens | null>(null);
    const isActive = computed(() => tutorialActive.value);

    const setActive = (val: boolean) => tutorialActive.value = val;
    const setActiveIfNotViewed = () => {
        if (tutorialViewed.value === false){
            tutorialActive.value = true;
        }
    }

    

    const persist = () => {
        toLocalStorage<TutorialPersistedState>('tutorial-store', {
            tutorialViewed: tutorialViewed.value
        })
    }

    const endScreenCallback = ref<Function | null>(null);
    const hide = () => {
        activeScreen.value = null;
        endScreenCallback.value?.();
    }

    const show = (key: keyof TutorialScreens) => {
        if (tutorialActive.value && screens.value[key] === false){
            activeScreen.value = key;
            screens.value[key] = true;
            return new Promise((resolve) => {
                tutorialViewed.value = true;
                persist();
                endScreenCallback.value = () => resolve(null);
            }); 
        }
    }

    /**
     * Resets tutorial screen state, marking each as "unseen".
     */
    const reset = () => {
        hide();
        screens.value = getTutorialScreenState();
    }

    return {
        activeScreen,
        setActive,
        setActiveIfNotViewed,
        isActive,
        show,
        hide,
        reset
    }
})

export { useTutorialStore };